import React, { use, useEffect, useState } from "react";
import {
    Box,
    Grid,
    Typography,
    Card,
    CardContent,
    Button,
    Divider,
    ToggleButton,
    ToggleButtonGroup,
    Dialog, DialogTitle, DialogContent, DialogActions,
    IconButton,
    TextField, FormControl,
    Alert
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { IconAlertTriangle, IconX } from "@tabler/icons-react";
import { useForm } from "react-hook-form";
import { BeatLoader } from "react-spinners";
const PlansPage = () => {
    const [billingCycle, setBillingCycle] = useState("Monthly");

    const handleBillingChange = (event, newBillingCycle) => {
        if (newBillingCycle) {
            setBillingCycle(newBillingCycle);
        }
        setselectedCard(null);
        setselectedplan([])
    };
    const { register, handleSubmit, formState: { errors }, trigger, setValue } = useForm();
    const [plans, setPlans] = useState([])
    const navigate = useNavigate()
    const [openDialog, setOpenDialog] = useState(false);
    const [OpenMail, setOpenMail] = useState(false)
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [activePlan, setActivePlan] = useState(null);
    const [ActivePlanData, setActivePlanData] = useState(null);
    const [error, seterror] = useState('')
    const [loader, setloader] = useState(false)
    const [openSuccess, setOpenSuccess] = useState(false);
    const [referenceId, setReferenceId] = useState(null);
    const [Deletepopup, setDeletepopup] = useState(false) 
    const [successPopup, setSuccessPopup] = useState(false) 
    const [Errorpopup,setErrorpopup]= useState(false)
    const [errorMessage,seterrorMessage]= useState('')
    const [planid,setplanid]=useState('')
    const UserInfo =JSON.parse(sessionStorage.getItem("user-info"));
    const [selectedCard,setselectedCard]= useState(null)
    const [selectedCardtype,setselectedCardtype]= useState(null)
    const GetPlans = async (planType=billingCycle) => {
        try {
            setloader(true)
            const response = await axios.get(`/apiV1/list-subscription/`);
            if (response.status === 200) {
                const fetchedPlans = response.data;
                const filteredPlans = fetchedPlans.filter(plan => plan.plan_type === planType);
                setPlans(filteredPlans)
                setloader(false)
            }
        } catch (err) {
            console.log("Error fetching plans:", err);
            setloader(false)
        }
    };
    const GetactivePlan = async () => {
        try {
            const response = await axios.get("/apiV1/list-assigned-subscription/");
            if (response.status === 200) {
                setActivePlanData(response.data[0])
            }
        } catch (err) {
            console.log("Error fetching plans:", err);
        }
    };
    const handleSendEmail = async (data) => {
        setloader(true)
        try {
            let req = {
                plan_id: data?.id,
            }
            const response = await axios.post('/apiV1/assign-subscription/', req)
            if (response.status == 200) {
                setOpenSuccess(true)
                setReferenceId(response.data.reference_id)
                setloader(false)
                setOpenMail(false)
            }
        } catch (err) {
            console.log(err);
            seterror(err.response.data.message)
            setloader(false)
        }

    }
    useEffect(() => {
        GetPlans()
        GetactivePlan()
    }, [billingCycle])
    useEffect(() => {
        if (plans.length > 0) {
            const currentPlan = plans.find(plan => plan.is_current_plan === true);
             setActivePlan(currentPlan?.id);
        }
    }, [plans]);
    useEffect(() => {
        setValue("email", "enquiry@pranathiss.com");
        setValue("planName", selectedPlan?.name || "");
    }, [setValue, selectedPlan]);
    const handleCancel = async () => {
        try {
            let req = {
                current_subscription_id: planid
            }
            const response = await axios.post('/apiV1/cancel-subscription/', req)
            if (response.status === 200) {
                setSuccessPopup(true)
            }
        } catch (err) {
            console.log(err);
            setDeletepopup(false)
            setErrorpopup(true)
            seterrorMessage(err.response.data.message)

        }
    }
    const [selectedplan, setselectedplan] = useState([]);
    const GetsinglePlanData=async(data)=>
        {
            try
            {
                const response = await axios.get(`/apiV1/get-plan-bill-details/?plan_id=${data}&user_id=${UserInfo.id}`)
                 if (response.status === 200) {
                        setselectedplan(response.data)
                 }
            }catch(err)
            {
                console.log(err);
                
            }
        }
        const handleCardClick = (index) => {
            setselectedCard(index);
        };
        const CreateNewBillingDetails = async() => {
            // let amount = 0
            //     Object.values(selectedplan).forEach((planamount) => {
            //         amount += planamount.amount;
            //     });
                // let bill_info = {
                //     pro_rata_details: selectedplan.pro_rata_details || {},
                //     regular_plan_details: selectedplan.regular_plan_details || {}
                // };
                let bill_info = {};
                if (selectedCardtype === "regular_plan_details") {
                    bill_info = {
                        pro_rata_details: selectedplan.regular_plan_details || {},
                        regular_plan_details: selectedplan.regular_plan_details || {}
                    };
                } else {
                    bill_info = {
                        pro_rata_details: selectedplan.pro_rata_details || {},
                        regular_plan_details: selectedplan.regular_plan_details || {}
                    };
                }
                let req = {
                    customer_id: UserInfo.id,
                    order_meta: {
                        bill_info: bill_info
                    }
                };
            try{
                const response = await axios.post ('/apiV1/create-subscription-order/',req)
                if (response.status === 200) {
                    navigate(`/billing?id=${response.data.data.order_id}&selectedplanid=${activePlan}&currentplanid=${ActivePlanData?.id}&type=${ActivePlanData?.is_renewal === false ? "NEW":"RENEWAL"}`)
                }
            }catch(err)
            {
                console.log(err);
                
            }
            
        }
    return (
        <>
             <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box>
                        <ToggleButtonGroup
                            value={billingCycle}
                            exclusive
                            onChange={handleBillingChange}
                            sx={{
                                // margin: "auto",
                                mx: 1,
                                marginBottom: 4,
                                display: "flex",
                                justifyContent: "center",
                                borderRadius: "8px",
                                width: "fit-content",
                                border: "1px solid #ddd",
                            }}
                        >
                            <ToggleButton
                                value="Monthly"
                                sx={{
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    "&.Mui-selected": {
                                        backgroundColor: "#07659b",
                                        color: "#fff",
                                        "&:hover": {
                                            backgroundColor: "#66a321",
                                        },
                                    },
                                    minWidth: "120px",
                                }}
                            >
                                Monthly
                            </ToggleButton>
                            <ToggleButton
                                value="Annually"
                                sx={{
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    "&.Mui-selected": {
                                        backgroundColor: "#07659b",
                                        color: "#fff",
                                        "&:hover": {
                                            backgroundColor: "#66a321",
                                        },
                                    },
                                    minWidth: "120px",
                                }}
                            >
                                Annually
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                    <Box >
                        <Button variant="contained" sx={{mr:2}} onClick={() =>navigate('/Carddetails')}>Card Details</Button>
                        <Button variant="contained" onClick={()=>navigate('/transactionhistory')}>Transaction History</Button>
                    </Box>
                </Box>
            {loader ? (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "70vh" }}>
                    <BeatLoader color="#07659c" size={24} />
                </Box>
            ) : plans.length === 0 ? (
                <Box sx={{ textAlign: "center", padding: 3 }}>
                    <Typography>No plans Available</Typography>
                </Box>
            ) : (
                <Card
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        p: 5,
                        margin: "0px 0px 0px 9px",
                        // position: "relative",
                        // justifyContent: "center",
                        boxShadow:
                            "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                        // height: "82vh"
                    }}
                >

                    <Grid container spacing={2} sx={{display:"flex",justifyContent:"space-between"}}>
                      <Grid item xs={12} sm={9} md={8} lg={9} sx={{ display: "flex", justifyContent: "space-between" }}>

                        {plans.map((plan) => (
                            <Grid item xs={12} sm={6} md={4} key={plan.id}>
                                <Card
                                    onClick={() => {setActivePlan(plan.id);GetsinglePlanData(plan.id)}}
                                    sx={{
                                        backgroundColor: "#ffffff",
                                        borderRadius: "15px",
                                        justifyContent: "space-evenly",
                                        maxWidth: 350,
                                        margin: "auto",
                                        boxShadow:
                                            activePlan === plan.id
                                                ? "0px 8px 20px rgba(74, 58, 255, 0.2)"
                                                : "none",
                                        border:
                                            activePlan === plan.id
                                                ? "2px solid #66a321"
                                                : "1px solid #e0e0e0",
                                        padding: "15px",
                                    }}
                                >
                                    <CardContent>
                                        {plan.is_current_plan && (
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    width: "100%",
                                                    position: "relative",
                                                    bottom: "31px",
                                                    left: "33px",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        backgroundColor: "#66a321",
                                                        color: "#fff",
                                                        fontSize: "12px",
                                                        fontWeight: "bold",
                                                        padding: "6px 8px",
                                                    }}
                                                >
                                                    Current Plan
                                                </Box>
                                            </Box>
                                        )}

                                        <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: 1 }}>
                                            {plan.name}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {plan.description}
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            sx={{ fontWeight: "bold", marginTop: 2, marginBottom: 2 }}
                                        >
                                            ${plan.price}
                                        </Typography>
                                        {plan.duration_months && <Typography sx={{ mb: 2 }}>Duration Months : {plan.duration_months}</Typography>}
                                        {plan.trial && (
                                            <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 2 }}>
                                                {plan.trial}
                                            </Typography>
                                        )}
                                        <Divider sx={{ marginBottom: 2 }} />
                                        <Box>
                                            {plan.perks?.length > 0 ? (
                                                plan.perks?.map((feature, i) => (
                                                    <Typography key={i} variant="body1" sx={{ marginBottom: 1, textAlign: "left" }}>
                                                        ✓ {typeof feature === "string" ? feature : feature.name || "Feature"}
                                                    </Typography>
                                                ))
                                            ) : (
                                                <Typography variant="body2" color="text.secondary">
                                                    No features available
                                                </Typography>
                                            )}
                                        </Box>

                                        <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
                                        {plan.is_current_plan ? <Button
                                            fullWidth
                                            variant="contained"
                                            disabled={plan.id !== activePlan}
                                            sx={{
                                                marginTop: 2,
                                                color: "#fff",
                                                fontWeight: "bold",
                                            }}
                                            onClick={() => { setOpenDialog(true)}} > View Details
                                        </Button>
                                            :"" }
                                        {plan.is_current_plan && ActivePlanData?.is_cancelled === false ? <Button
                                            fullWidth
                                            variant="outlined"
                                            disabled={plan.id !== activePlan}
                                            sx={{ marginTop: 2, color: "#fff",fontWeight: "bold", backgroundColor:plan.id === activePlan?"#c63137":"#e0e0e0"}}
                                            onClick={() => {{setDeletepopup(true);setplanid(ActivePlanData.id)}}}
                                        > Cancel Plan
                                        </Button>:""}
                                        {plan.is_current_plan && ActivePlanData?.is_cancelled === true ? <Typography sx={{mt:2,textAlign:"center",color:"red"}}>Your plan has been canceled</Typography>:""}
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                        {Object.entries(selectedplan).map(([key, pland], i) => {
                            return (
                                <Card 
                                    key={i} 
                                    style={{marginBottom: "15px",padding: "10px",fontSize:'14px',borderRadius:"10px",border: selectedCard === i ? "1px solid #104672":"",backgroundColor: selectedCard === i ? "#c9e3f1":""}} 
                                    mt={2} 
                                    onClick={() => {handleCardClick(i);setselectedCardtype(key)}} 
                                    // className={selectedplan === i ? 'selected' : ''}
                                    
                                >
                                    <Typography 
                                        variant="h6" 
                                        style={{ 
                                            color: "#182286", 
                                            fontSize: '16px', 
                                            display: "flex", 
                                            alignItems: "center", 
                                            gap: "8px" 
                                        }}
                                        >
                                        <input type="radio" checked={selectedCard === i} /> 
                                        {key === 'pro_rata_details' ? "Prorated Amount" : "Full Amount"}
                                        </Typography>


                                    <Typography sx={{ pt: 2, pb: 2,fontSize:'14px' }}>
                                        {key === 'pro_rata_details' 
                                            ? "Amount & services are calculated for the remaining days left in the current month." 
                                            : "Full amount will be debited as per the current plan."
                                        }
                                    </Typography>

                                    <Box  sx={{ mb: 2,display:"flex"}}>
                                        <Box mr="auto">
                                            <Typography sx={{ maxWidth: '150px',fontSize:'14px' }}>Current Plan</Typography>
                                        </Box>
                                        <Box style={{ color: "#182286", fontWeight: "bold" ,fontSize:'14px'}}> {pland.plan_name} </Box>
                                    </Box>

                                    {/* <Box  sx={{ mb: 2,display:"flex" }}>
                                        <Box mr="auto">
                                            <Typography sx={{ maxWidth: '150px',fontSize:'14px' }}>Remaining days</Typography>
                                        </Box>
                                        <Box style={{ color: "#182286", fontWeight: "bold",fontSize:'14px' }}> -- </Box>
                                    </Box> */}

                                    <Box  sx={{ mb: 2,display:"flex" }}>
                                        <Box mr="auto">
                                            <Typography sx={{ maxWidth: '150px',fontSize:'14px' }}>No of Projects</Typography>
                                        </Box>
                                        <Box style={{ color: "#182286", fontWeight: "bold",fontSize:'14px' }}> {pland.no_of_projects_allowed} </Box>
                                    </Box>

                                    <Box  sx={{ mb: 2,display:"flex" }}>
                                        <Box mr="auto">
                                            <Typography sx={{ maxWidth: '150px',fontSize:'14px' }}>No of Masterinputs</Typography>
                                        </Box>
                                        <Box style={{ color: "#182286", fontWeight: "bold",fontSize:'14px' }}> {pland.no_regenerate_master_input} </Box>
                                    </Box>
                                    <Box  sx={{ mb: 2,display:"flex" }}>
                                        <Box mr="auto">
                                            <Typography sx={{ maxWidth: '150px',fontSize:'14px' }}>No of Documents</Typography>
                                        </Box>
                                        <Box style={{ color: "#182286", fontWeight: "bold",fontSize:'14px' }}> {pland.no_regenerate_individual_docs } </Box>
                                    </Box>
                                    <Box  sx={{ mb: 2,display:"flex" }}>
                                        <Box mr="auto">
                                            <Typography sx={{ maxWidth: '150px',fontSize:'14px' }}>No of Wireframes</Typography>
                                        </Box>
                                        <Box style={{ color: "#182286", fontWeight: "bold",fontSize:'14px' }}> {pland.no_regenerate_individual_wireframes } </Box>
                                    </Box>
                                    <Box  sx={{ mb: 2,display:"flex" }}>
                                        <Box mr="auto">
                                            <Typography sx={{ maxWidth: '150px',fontSize:'14px' }}>No of Ai Suggestions</Typography>
                                        </Box>
                                        <Box style={{ color: "#182286", fontWeight: "bold",fontSize:'14px' }}> {pland.ai_suggestions_allowed} </Box>
                                    </Box>
                                    <Divider/>
                                    <Box  sx={{ mt: 2,display:"flex" }}>
                                        <Box mr="auto">
                                            <Typography sx={{ maxWidth: '150px',fontSize:'14px' }}>Total Amount</Typography>
                                        </Box>
                                        <Box style={{ color: "#182286", fontWeight: "bold",fontSize:'14px' }}> {"$" + pland.amount} </Box>
                                    </Box>
                                    {/* <Box  sx={{ mb: 2,display:"flex" }}>
                                        <TextField 
                                            fullWidth 
                                            variant="outlined" 
                                            className='textfieldsininput' 
                                            InputProps={{ readOnly: true }} 
                                            value={"$" + pland.amount} 
                                        />
                                    </Box> */}
                                </Card>
                            );
                        })}

                            {selectedCard !==null ? <Box sx={{display:"flex",gap:2}}>
                                <Button onClick={()=>{{setselectedCard(null);setselectedplan([]);setActivePlan(null)}}}>Cancel</Button>
                                <Button className="button2" onClick={CreateNewBillingDetails}>Buy</Button> </Box>:"" }
                        </Grid>
                    </Grid>
                </Card>
            )}
            {error && <Alert severity="error">{error}</Alert>}

            <Dialog open={openSuccess} onClose={() => setOpenSuccess(false)} fullWidth maxWidth="sm">
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Success
                    <IconButton onClick={() => setOpenSuccess(false)}>
                        <IconX size={24} />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent sx={{ textAlign: "center" }}>
                    <Typography variant="body1" gutterBottom>
                        Subscription email sent successfully.
                    </Typography>
                    <Typography variant="body2">
                        <strong>Reference ID:</strong> {referenceId}
                    </Typography>
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ marginTop: 1, fontSize: "small" }}
                        onClick={() => {
                            navigator.clipboard.writeText(referenceId);
                        }}
                    >
                        Copy
                    </Button>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenSuccess(false)} variant="contained" color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                    open={Deletepopup}
                    onClose={() => setDeletepopup(false)}
                    aria-labelledby="confirm-cancel-dialog-title"
                    aria-describedby="confirm-cancel-dialog-description"
                    PaperProps={{
                        sx: { borderRadius: '16px', padding: '16px' },
                    }}
                >
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box />
                        <IconButton size="small" onClick={() => setDeletepopup(false)}>
                            <IconX />
                        </IconButton>
                    </Box>
                    <DialogTitle id="confirm-cancel-dialog-title" align="center" sx={{ marginTop: -3 }}>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    backgroundColor: '#fff3cd',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '50%',
                                    marginBottom: 2,
                                }}
                            >
                                <IconAlertTriangle size={32} color="#ff9800" />
                            </Box>
                        </Box>
                        <Typography variant="h6" fontWeight="bold">
                            Confirm Cancellation
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Typography id="confirm-cancel-dialog-description" align="center">
                            Are you sure you want to cancel your plan? You will lose access to premium features.
                        </Typography>
                    </DialogContent>
                    <DialogActions
                        sx={{ display: 'flex', justifyContent: 'center', gap: 2, marginBottom: 1 }}
                    >
                        <Button
                            variant="outlined"
                            color="inherit"
                            onClick={() => setDeletepopup(false)}
                        >
                            Keep Plan
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            sx={{ backgroundColor: "#c63037", border: "none" }}
                            onClick={handleCancel}
                        >
                            Cancel Plan
                        </Button>
                    </DialogActions>
                </Dialog>
            {/* <Dialog open={OpenMail} onClose={() => setOpenMail(false)}>
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Contact Sales
                    <IconButton onClick={() => setOpenMail(false)}>
                        <IconX size={24} />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Box>
                        <form onSubmit={handleSubmit(handleSendEmail)}>
                            <FormControl variant="standard" fullWidth margin="dense">
                                <Typography variant="body2" gutterBottom>Email</Typography>
                                <TextField
                                    fullWidth
                                    id="email-input"
                                    type="email"
                                    disabled
                                    {...register("email")}
                                />
                            </FormControl>
                            <FormControl variant="standard" fullWidth margin="dense">
                                <Typography variant="body2" gutterBottom>Plan Name</Typography>
                                <TextField
                                    fullWidth
                                    id="plan-name-input"
                                    disabled
                                    {...register("planName")}
                                />
                            </FormControl>
                            <FormControl variant="standard" fullWidth margin="dense">
                                <Typography variant="body2" gutterBottom>Message</Typography>
                                <textarea
                                    id="message-input"
                                    rows={4}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        fontSize: "16px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        outline: "none",
                                        resize: "vertical"
                                    }}
                                    {...register("message", { required: "Message is required" })}
                                    onKeyUp={() => trigger("message")}
                                    error={!!errors.message}
                                    helperText={errors.message?.message}
                                />
                            </FormControl>
                            {error && <Alert>{error}</Alert>}
                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => setOpenMail(false)}
                                    sx={{ textTransform: "none" }}
                                    disabled={loader}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    className="button2"
                                    disabled={loader}
                                >
                                    {loader ? <BeatLoader size={20} color="#4a77f8" /> : <Typography>Send Mail</Typography>}
                                </Button>
                            </Box>
                        </form>
                    </Box>
                </DialogContent>
            </Dialog> */}

            <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Current Plan Details
                    <IconButton onClick={() => setOpenDialog(false)}>
                        <IconX size={24} />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {ActivePlanData && <>
                        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                            {ActivePlanData.plan_details.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            {ActivePlanData.plan_details.description}
                        </Typography>
                        <Typography variant="h5" sx={{ mb: 1 }}>
                            ${ActivePlanData.plan_details.price} / {ActivePlanData.plan_details.duration_months} month(s)
                        </Typography>
                        <Typography sx={{ mb: 1 }}>
                            Start Date : {new Date(ActivePlanData.created_at).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                            }).replace(/\//g, "-")}
                        </Typography>
                        <Typography sx={{ mb: 1 }}>
                            End Date : {new Date(ActivePlanData.end_date).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                            }).replace(/\//g, "-")}

                        </Typography>

                        <Typography sx={{ mb: 1 }}>
                            Remaining Projects: {ActivePlanData?.total_projects_remaining}/{ActivePlanData?.total_projects}
                        </Typography>
                        <Typography sx={{ mb: 1 }}>
                            Remaining Ai Suggestions: {ActivePlanData?.remaining_ai_suggestions}/{ActivePlanData?.total_ai_suggestions}
                        </Typography>
                        <Typography sx={{ mb: 1 }}>
                            Remaining Users: {ActivePlanData?.remaining_users_allowed}/{ActivePlanData?.total_users_allowed}
                        </Typography>
                        <Typography sx={{ mb: 1 }}>
                            Remaining individual docs: {ActivePlanData?.remaining_regenerate_individual_docs}/{ActivePlanData?.total_regenerate_individual_docs}
                        </Typography>
                        <Typography sx={{ mb: 1 }}>
                            Remaining Master input: {ActivePlanData?.remaining_regenerate_master_input}/{ActivePlanData?.total_regenerate_master_input}
                        </Typography>
                        <Typography sx={{ mb: 1 }}>
                            Remaining Wireframes : {ActivePlanData?.remaining_regenerate_individual_wireframes}/{ActivePlanData?.total_regenerate_individual_wireframes}
                        </Typography>
                    </>}
                    <Divider />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} color="primary" variant="contained">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default PlansPage;
